<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="800px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ sutartisTitle }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2 py-4">
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="12">
                <v-skeleton-loader
                  v-if="contentloading"
                  type="list-item-three-line"
                ></v-skeleton-loader>
                <span
                  class="sutartis-content"
                  v-if="!contentloading"
                  v-html="content"
                ></span>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button @click.native="cancel()" :loading="loading">
          Nesutinku
        </el-button>
        <el-button primary @click.native.stop="submit()" :loading="loading">
          Sutinku
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalSavitarnaSutartis',
  props: {
    value: Boolean,
    loading: Boolean,
    ntrpaslaugos: Boolean,
  },
  data() {
    return {
      content: null,
      contentloading: true,
    }
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    sutartisTitle() {
      if (this.ntrpaslaugos) {
        return 'Elektroninių NTR paslaugų naudojimo sutartis'
      }
      return 'Savitarnos paslaugų naudojimo sutartis'
    },
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.contentloading = true

      this.$axios
        .get(`naudojimo-sutartis`)
        .then(res => {
          if (this.ntrpaslaugos) {
            this.content = res.data.html_ntrpaslaugos
            return
          }
          this.content = res.data.html
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.contentloading = false
        })
    },
    submit() {
      this.$emit('confirmSutartis')
      this.closeModal()
    },
    cancel() {
      this.$emit('cancelSutartis')
      this.closeModal()
    },
    closeModal() {
      this.showModal = false
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
